import React from "react";
import './Copyright.css'

const Copyright = () => {
  return (
    <div className="CopyrightContainer">
      © 2024 Techni Trust Technical Services | Website by Dimark
      Marketing Management LLC.
    </div>
  );
};

export default Copyright;
